import React from 'react';
import PropTypes from 'prop-types';
import Online from './Online';
import Article from './Article';

export default function WidgetList(props) {
	return props.articles.map((article, index) => {
		if (article.isOnline) {
			return <Online key={index} {...article} />
		}
		return <Article key={index} {...article} />
	});
}

WidgetList.propTypes = {
	articles: PropTypes.arrayOf(PropTypes.object).isRequired
};
